import React from "react";
import "./privacyPolicy.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";

import { t } from "i18next";
import { Container } from "react-bootstrap";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="d-flex justify-content-center">
        <HeaderBar title={t("privacy_policy.title")} back={true} />
      </div>
      <Container>
        <div className="">
          <h1>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Politica sulla riservatezza
              </font>
            </font>
          </h1>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Ultimo aggiornamento: 4 aprile 2025
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                La presente “Informativa sulla privacy” descrive le nostre
                politiche e procedure sulla raccolta, l'uso e la divulgazione
                delle tue informazioni quando utilizzi il “Servizio” e ti
                informa sui tuoi diritti alla privacy e su come la legge ti
                protegge.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Utilizziamo i tuoi dati personali per fornire e migliorare il
                Utilizziamo i tuoi dati personali per fornire e migliorare il
                “Servizio”. Utilizzando il “Servizio, accetti la raccolta e
                l'utilizzo delle informazioni in conformità con la presente
                Informativa sulla privacy. La presente “Informativa sulla
                privacy” è stata creata con l'aiuto del{" "}
              </font>
            </font>
            <a
              href="https://www.termsfeed.com/privacy-policy-generator/"
              target="_blank"
            >
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  Generatore di Informativa sulla privacy
                </font>
              </font>
            </a>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> .</font>
            </font>
          </p>
          <h2>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Interpretazione e definizioni
              </font>
            </font>
          </h2>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Interpretazione</font>
            </font>
          </h3>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Le parole la cui lettera iniziale è maiuscola hanno significati
                definiti alle seguenti condizioni. Le seguenti definizioni
                avranno lo stesso significato indipendentemente dal fatto che
                appaiano al singolare o al plurale.
              </font>
            </font>
          </p>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Definizioni</font>
            </font>
          </h3>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Ai fini della presente “Informativa sulla privacy” sono
                riportate di seguito una serie di definzioni:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>Account</font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    account univoco creato per consentirti di accedere al nostro
                    Servizio o a parti del nostro Servizio.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>Affiliata</font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    un'entità che controlla, è controllata da o è sotto il
                    controllo comune di una parte, dove "controllo" significa
                    proprietà del 50% o più delle azioni, partecipazione al
                    capitale o altri titoli che danno diritto al voto per
                    l'elezione degli amministratori o di altre autorità di
                    gestione.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>Il Team</font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    (denominato nel presente Contratto "il Team", "Noi", "Ci" o
                    "Nostro") si riferisce a Volunteer.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>Cookie</font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    piccoli file che vengono salvati sul tuo computer,
                    dispositivo mobile o qualsiasi altro dispositivo da un sito
                    web e che contengono, tra i vari utilizzi, i dettagli della
                    tua cronologia di navigazione su quel sito.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>Il paese</font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    si riferisce all'Italia
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Dispositivo
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    qualsiasi dispositivo in grado di accedere al “Servizio”, ad
                    esempio un computer, un cellulare o un tablet digitale.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Dati personali
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    tutte quelle informazioni relative ad una persona fisica
                    identificata o identificabile.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per Servizio
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    si intende il Sito Web.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Fornitore di servizi
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    qualsiasi persona fisica o giuridica che elabora i dati per
                    conto di Volunteer. Si riferisce a società terze o individui
                    impiegati da Volunteer per facilitare il “Servizio”, per
                    fornire il “Servizio” per conto di Volunteer, per eseguire
                    servizi correlati al “Servizio” o per assistere Volunteer
                    nell'analisi delle modalità di utilizzo del “Servizio”.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      I Dati di Utilizzo
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    dati raccolti automaticamente, generati dall'utilizzo del
                    “Servizio” o dall'infrastruttura del “Servizio” stesso (ad
                    esempio, la durata della visita di una pagina).
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Il sito web
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    fa riferimento a Volunteer, accessibile da{" "}
                  </font>
                </font>
                <a
                  href="https://app-volunteer.com"
                  rel="external nofollow noopener"
                  target="_blank"
                >
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      https://app-volunteer.com
                    </font>
                  </font>
                </a>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per "Utente"
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    si intende la persona che accede o utilizza il “Servizio”,
                    oppure la società o altra entità giuridica per conto della
                    quale tale persona accede o utilizza il “Servizio”, a
                    seconda dei casi.
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <h2>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Raccolta e utilizzo dei tuoi dati personali
              </font>
            </font>
          </h2>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Tipi di dati raccolti
              </font>
            </font>
          </h3>
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Dati Personali</font>
            </font>
          </h4>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Durante l'utilizzo del “Servizio” offerto da Volunteer, potremmo
                chiederti di fornirci alcune informazioni di identificazione
                personale che possono essere utilizzate per contattarti o
                identificarti. Le informazioni di identificazione personale
                possono includere, ma non sono limitate a:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Indirizzo e-mail
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Nome e cognome
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Numero di telefono
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Dati di utilizzo
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Dati di utilizzo</font>
            </font>
          </h4>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                I “Dati di Utilizzo” vengono raccolti automaticamente durante
                l'utilizzo del “Servizio”.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                I “Dati di utilizzo” possono includere informazioni quali
                l'indirizzo IP (Internet Protocol) del tuo Dispositivo (ad
                esempio, l'indirizzo IP), il tipo di browser, la versione del
                browser, le pagine del nostro Servizio che visiti, l'ora e la
                data della tua visita, il tempo trascorso su tali pagine,
                identificatori univoci del dispositivo e altri dati diagnostici.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Quando accedi al “Servizio” tramite un dispositivo mobile,
                potremmo raccogliere automaticamente determinate informazioni,
                tra cui, a titolo esemplificativo ma non esaustivo, il tipo di
                dispositivo mobile che utilizzi, l'ID univoco del tuo
                dispositivo mobile, l'indirizzo IP del tuo dispositivo mobile,
                il sistema operativo mobile, il tipo di browser Internet mobile
                che utilizzi, identificatori univoci del dispositivo e altri
                dati diagnostici.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Potremmo anche raccogliere informazioni che il tuo browser invia
                ogni volta che visiti il nostro “Servizio” o quando accedi al
                “Servizio” tramite un dispositivo mobile.
              </font>
            </font>
          </p>
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Tecnologie di tracciamento e cookie
              </font>
            </font>
          </h4>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Utilizziamo Cookie e tecnologie di tracciamento simili per
                tracciare l'attività sul nostro “Servizio” e memorizzare
                determinate informazioni. Le tecnologie di tracciamento
                utilizzate sono beacon, tag e script per raccogliere e tracciare
                informazioni e per migliorare e analizzare il nostro “Servizio”.
                Le tecnologie che utilizziamo possono includere:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Cookie o Cookie del browser.
                  </font>
                </font>
              </strong>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  {" "}
                  Un Cookie è un piccolo file inserito nel tuo Dispositivo. Puoi
                  indicare al tuo browser di rifiutare tutti i Cookie o di
                  indicare quando viene inviato un Cookie. Tuttavia, se non
                  accetti i Cookie, potresti non essere in grado di utilizzare
                  alcune parti del nostro “Servizio”. A meno che tu non abbia
                  modificato le impostazioni del tuo browser in modo che rifiuti
                  i Cookie, il nostro Servizio potrebbe utilizzare i Cookie.
                </font>
              </font>
            </li>
            <li>
              <strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>Web Beacon.</font>
                </font>
              </strong>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  {" "}
                  Alcune sezioni del nostro “Servizio” e le nostre e-mail
                  possono contenere piccoli file elettronici noti come web
                  beacon (chiamati anche clear gif, pixel tag e single-pixel
                  gif) che consentono a Volunteer, ad esempio, di contare gli
                  utenti che hanno visitato quelle pagine o aperto un'e-mail e
                  per altre statistiche correlate del sito Web (ad esempio,
                  registrando la popolarità di una determinata sezione e
                  verificando l'integrità del sistema e del server).
                </font>
              </font>
            </li>
          </ul>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                I Cookie possono essere "Persistenti" o "Sessionali". I “Cookie
                Persistenti” rimangono sul tuo personal computer o dispositivo
                mobile quando vai offline, mentre i “Cookie di Sessione” vengono
                eliminati non appena chiudi il tuo browser web. Puoi saperne di
                più sui cookie nell'articolo{" "}
              </font>
            </font>
            <a
              href="https://www.termsfeed.com/blog/cookies/#What_Are_Cookies"
              target="_blank"
            >
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  del sito web TermsFeed
                </font>
              </font>
            </a>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> .</font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Utilizziamo sia i “Cookie di Sessione” che i “Cookie
                Persistenti” per gli scopi indicati di seguito:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Cookie necessari / essenziali
                    </font>
                  </font>
                </strong>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Tipo: Cookie di sessione
                  </font>
                </font>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Amministrato da: Noi
                  </font>
                </font>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Scopo: Questi Cookie sono essenziali per fornirti i servizi
                    disponibili tramite il Sito Web e per consentirti di
                    utilizzare alcune delle sue funzionalità. Aiutano ad
                    autenticare gli utenti e a prevenire l'uso fraudolento degli
                    account utente. Senza questi Cookie, i servizi che hai
                    richiesto non possono essere forniti e utilizziamo questi
                    Cookie solo per fornirti tali servizi.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Informativa sui cookie / Informativa sull'accettazione dei
                      cookie
                    </font>
                  </font>
                </strong>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Tipo: Cookie persistenti
                  </font>
                </font>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Amministrato da: Noi
                  </font>
                </font>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Scopo: Questi Cookie identificano se gli utenti hanno
                    accettato l'uso dei cookie sul Sito Web.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Cookie di funzionalità
                    </font>
                  </font>
                </strong>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Tipo: Cookie persistenti
                  </font>
                </font>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Amministrato da: Noi
                  </font>
                </font>
              </p>
              <p>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Scopo: Questi Cookie ci consentono di ricordare le scelte
                    che fai quando utilizzi il Sito Web, come ricordare i tuoi
                    dati di accesso o la preferenza di lingua. Lo scopo di
                    questi Cookie è di fornirti un'esperienza più personale ed
                    evitare che tu debba reinserire le tue preferenze ogni volta
                    che utilizzi il Sito Web.
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Per maggiori informazioni sui cookie che utilizziamo e sulle tue
                scelte in merito, visita la nostra “Politica sui cookie” o la
                sezione Cookie della nostra Informativa sulla privacy.
              </font>
            </font>
          </p>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Utilizzo dei tuoi dati personali
              </font>
            </font>
          </h3>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Volunteer potrà utilizzare i Dati Personali per le seguenti
                finalità:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per fornire e mantenere il nostro Servizio
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    , incluso il monitoraggio dell'utilizzo del nostro
                    “Servizio”;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per gestire il tuo Account:
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    per gestire la tua registrazione come “Utente” del
                    “Servizio”. I Dati Personali che fornisci possono darti
                    accesso a diverse funzionalità del “Servizio” che sono
                    disponibili per te come utente registrato;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per l'esecuzione di un contratto:
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    lo sviluppo, la conformità e l'esecuzione del contratto di
                    acquisto per i prodotti, gli articoli o i servizi da te
                    acquistati o di qualsiasi altro contratto con noi tramite il
                    “Servizio”;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per contattarti:
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    per contattarti tramite e-mail, telefonate, SMS o altre
                    forme equivalenti di comunicazione elettronica, come le
                    notifiche push di un'applicazione mobile relative ad
                    aggiornamenti o comunicazioni informative relative alle
                    funzionalità, ai prodotti o ai servizi contrattualizzati,
                    inclusi gli aggiornamenti di sicurezza, quando necessario o
                    ragionevole per la loro implementazione;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per fornirti
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    notizie, offerte speciali e informazioni generali su altri
                    beni, servizi ed eventi da noi offerti, simili a quelli che
                    hai già acquistato o su cui hai chiesto informazioni, a meno
                    che tu non abbia scelto di non ricevere tali informazioni;
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per gestire le tue richieste:
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    per soddisfare e gestire le tue richieste a Noi rivolte.
                  </font>
                </font>
              </p>
            </li>
            <li>
              <p>
                <strong>
                  <font style={{ verticalAlign: "inherit" }}>
                    <font style={{ verticalAlign: "inherit" }}>
                      Per altri scopi
                    </font>
                  </font>
                </strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    {" "}
                    : potremmo utilizzare le tue informazioni per altri scopi,
                    come l'analisi dei dati, l'identificazione delle tendenze di
                    utilizzo, la determinazione dell'efficacia delle nostre
                    campagne promozionali e per valutare e migliorare il nostro
                    “Servizio”, i nostri prodotti, i nostri servizi, il
                    marketing e la tua esperienza.
                  </font>
                </font>
              </p>
            </li>
          </ul>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Potremmo condividere le tue informazioni personali nelle
                seguenti situazioni:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Con i fornitori di servizi:
                  </font>
                </font>
              </strong>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  {" "}
                  potremmo condividere le tue informazioni personali con i
                  fornitori di servizi per monitorare e analizzare l'utilizzo
                  del nostro servizio e per contattarti;
                </font>
              </font>
            </li>
            <li>
              <strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Con gli affiliati:
                  </font>
                </font>
              </strong>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  {" "}
                  potremmo condividere le tue informazioni con i nostri
                  affiliati, nel qual caso richiederemo a tali affiliati di
                  rispettare la presente “Informativa sulla privacy”. Gli
                  affiliati includono la nostra società madre e qualsiasi altra
                  sussidiaria, partner di joint venture o altre società che
                  controlliamo o che sono sotto il nostro controllo comune;
                </font>
              </font>
            </li>
            <li>
              <strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Con i partner commerciali:
                  </font>
                </font>
              </strong>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  {" "}
                  potremmo condividere le tue informazioni con i nostri partner
                  commerciali per offrirti determinati prodotti, servizi o
                  promozioni;
                </font>
              </font>
            </li>
            <li>
              <strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Con altri utenti:
                  </font>
                </font>
              </strong>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  {" "}
                  quando condividi informazioni personali o interagisci in altro
                  modo nelle aree pubbliche con altri utenti, tali informazioni
                  possono essere visualizzate da tutti gli utenti e possono
                  essere distribuite pubblicamente all'esterno;
                </font>
              </font>
            </li>
            <li>
              <strong>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Con il tuo consenso
                  </font>
                </font>
              </strong>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  {" "}
                  : potremmo divulgare i tuoi Dati Personali per qualsiasi altro
                  scopo con il tuo consenso.
                </font>
              </font>
            </li>
          </ul>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Conservazione dei tuoi dati personali
              </font>
            </font>
          </h3>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Volunteer conserverà i tuoi Dati Personali solo per il tempo
                necessario agli scopi indicati nella presente “Informativa sulla
                Privacy”. Conserveremo e utilizzeremo i tuoi Dati Personali
                nella misura necessaria per ottemperare ai nostri obblighi
                legali (ad esempio, se siamo tenuti a conservare i tuoi dati per
                ottemperare alle leggi applicabili), risolvere controversie e
                far rispettare i nostri accordi e le nostre politiche legali.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Volunteer conserverà inoltre i Dati di Utilizzo per scopi di
                analisi interna. I Dati di Utilizzo vengono generalmente
                conservati per un periodo di tempo più breve, eccetto quando
                questi dati vengono utilizzati per rafforzare la sicurezza o
                migliorare la funzionalità del Nostro Servizio, oppure siamo
                legalmente obbligati a conservare questi dati per periodi di
                tempo più lunghi.
              </font>
            </font>
          </p>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Trasferimento dei tuoi dati personali
              </font>
            </font>
          </h3>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Le tue informazioni, inclusi i Dati Personali, vengono elaborate
                presso gli uffici operativi di Volunteer e in qualsiasi altro
                luogo in cui si trovino le parti coinvolte nell'elaborazione.
                Ciò significa che queste informazioni possono essere trasferite
                a — e mantenute su — computer situati al di fuori del tuo stato,
                provincia, paese o altra giurisdizione governativa in cui le
                leggi sulla protezione dei dati potrebbero differire da quelle
                della tua giurisdizione.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Il tuo consenso alla presente “Informativa sulla privacy”
                seguito dall'invio di tali informazioni rappresenta il tuo
                consenso a tale trasferimento.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Volunteer adotterà tutte le misure ragionevolmente necessarie
                per garantire che i tuoi dati siano trattati in modo sicuro e in
                conformità con la presente “Informativa sulla privacy” e nessun
                trasferimento dei tuoi dati personali avverrà a
                un'organizzazione o a un paese a meno che non siano in atto
                controlli adeguati, inclusa la sicurezza dei tuoi dati e di
                altre informazioni personali.
              </font>
            </font>
          </p>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Elimina i tuoi dati personali
              </font>
            </font>
          </h3>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Hai il diritto di cancellare o di richiedere la nostra
                assistenza per la cancellazione dei dati personali che abbiamo
                raccolto su di te.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Il nostro “Servizio” potrebbe darti la possibilità di eliminare
                determinate informazioni che ti riguardano dall'interno del
                “Servizio”.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Puoi aggiornare, modificare o eliminare le tue informazioni in
                qualsiasi momento accedendo al tuo account, se ne hai uno, e
                visitando la sezione delle impostazioni dell'account che ti
                consente di gestire le tue informazioni personali. Puoi anche
                contattarci per richiedere l'accesso, la correzione o
                l'eliminazione di qualsiasi informazione personale che ci hai
                fornito.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Si prega di notare, tuttavia, che potremmo aver bisogno di
                conservare determinate informazioni quando abbiamo un obbligo
                legale o una base giuridica per farlo.
              </font>
            </font>
          </p>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Divulgazione dei tuoi dati personali
              </font>
            </font>
          </h3>
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Applicazione della legge
              </font>
            </font>
          </h4>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                In determinate circostanze, Volunteer potrebbe essere tenuto a
                divulgare i tuoi Dati Personali se richiesto dalla legge o in
                risposta a richieste valide da parte delle autorità pubbliche
                (ad esempio un tribunale o un'agenzia governativa).
              </font>
            </font>
          </p>
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Altri requisiti legali
              </font>
            </font>
          </h4>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Volunteer può divulgare i tuoi Dati Personali in buona fede
                ritenendo che tale azione sia necessaria per:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  Adempiere ad un obbligo legale
                </font>
              </font>
            </li>
            <li>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  Proteggere e difendere i diritti o la proprietà del Team
                </font>
              </font>
            </li>
            <li>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  Prevenire o investigare possibili illeciti in relazione al
                  “Servizio”
                </font>
              </font>
            </li>
            <li>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  Proteggere la sicurezza personale degli “Utenti” del
                  “Servizio” o del pubblico
                </font>
              </font>
            </li>
            <li>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  Proteggersi dalla responsabilità legale
                </font>
              </font>
            </li>
          </ul>
          <h3>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Sicurezza dei tuoi dati personali
              </font>
            </font>
          </h3>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                La sicurezza dei tuoi Dati Personali è importante per noi, ma
                ricorda che nessun metodo di trasmissione su Internet o metodo
                di archiviazione elettronica è sicuro al 100%. Mentre ci
                impegniamo a utilizzare mezzi commercialmente accettabili per
                proteggere i tuoi Dati Personali, non possiamo garantirne la
                sicurezza assoluta.
              </font>
            </font>
          </p>
          <h2>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Privacy dei bambini
              </font>
            </font>
          </h2>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Il nostro “Servizio” non si rivolge a persone di età inferiore
                ai 13 anni. Non raccogliamo consapevolmente informazioni
                personali identificabili da persone di età inferiore ai 13 anni.
                Se sei un genitore o un tutore e sei a conoscenza del fatto che
                tuo figlio ci ha fornito Dati Personali, ti preghiamo di
                contattarci. Se veniamo a conoscenza di aver raccolto Dati
                Personali da persone di età inferiore ai 13 anni senza la
                verifica del consenso dei genitori, adottiamo misure per
                rimuovere tali informazioni dai nostri server.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Se dobbiamo basarci sul consenso come base giuridica per
                elaborare le tue informazioni e il tuo Paese richiede il
                consenso di un genitore, potremmo richiedere il consenso del
                genitore prima di raccogliere e utilizzare tali informazioni.
              </font>
            </font>
          </p>
          <h2>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Collegamenti ad altri siti web
              </font>
            </font>
          </h2>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Il nostro “Servizio” potrebbe contenere link ad altri siti web
                che non sono gestiti da noi. Se clicchi su un link di terze
                parti, verrai indirizzato al sito di quella terza parte. Ti
                consigliamo vivamente di rivedere la specifica “Informativa
                sulla privacy” di ogni sito che visiti.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Non abbiamo alcun controllo e non ci assumiamo alcuna
                responsabilità per il contenuto, le politiche sulla privacy o le
                pratiche di siti o servizi di terze parti.
              </font>
            </font>
          </p>
          <h2>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Modifiche alla presente Informativa sulla privacy
              </font>
            </font>
          </h2>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Potremmo aggiornare la nostra “Informativa sulla privacy” di
                tanto in tanto. Ti informeremo di eventuali modifiche
                pubblicando la nuova “Informativa sulla privacy” su questa
                pagina.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Ti informeremo tramite e-mail e/o tramite un avviso ben visibile
                sul nostro “Servizio”, prima che la modifica diventi effettiva e
                aggiorneremo la data di "Ultimo aggiornamento" nella parte
                superiore della presente “Informativa sulla privacy”.
              </font>
            </font>
          </p>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Si consiglia di rivedere periodicamente la presente Informativa
                sulla privacy per eventuali modifiche. Le modifiche alla
                presente “Informativa sulla privacy” sono efficaci quando
                vengono pubblicate su questa pagina.
              </font>
            </font>
          </p>
          <h2>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Contattaci</font>
            </font>
          </h2>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Se hai domande sulla presente “Informativa sulla privacy”, puoi
                contattarci:
              </font>
            </font>
          </p>
          <ul>
            <li>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>Via email: </font>
              </font>
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  policy@app-volunteer.com
                </font>
              </font>
            </li>
          </ul>
        </div>
      </Container>
    </div>
  );
}
